import { ButtonContainer, FGCustomInput, FGCustomPanel, FGEmpty } from "nsitools-react";
import * as React from "react";
import { useParams } from "react-router";

import { SaveVeterinaryClinicDto, VeterinaryClinicApi, VeterinaryGridDto } from "../../../../api";
import { SaveButton, SmallFormGenerator } from "../../../../components";
import { useApiService, useSaveApi, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";

export interface IClinicVeterinariesControlFormPanelProps {
  veterinary: VeterinaryGridDto;
  onSaved: () => void;
}
export const ClinicVeterinariesControlFormPanel: React.FunctionComponent<IClinicVeterinariesControlFormPanelProps> = ({
  veterinary,
  onSaved,
}) => {
  const { t } = useTl();
  const veterinaryClinicApi = useApiService(VeterinaryClinicApi);
  const { id } = useParams<{ id: string }>();

  const { saving, saveItem } = useSaveApi(
    React.useMemo(
      () => ({
        saveApiFn: (data: SaveVeterinaryClinicDto) => veterinaryClinicApi.addNewVeterinary(data),
        onSaveFn: () => onSaved(),
      }),
      [veterinaryClinicApi, onSaved],
    ),
  );

  const initialData = React.useMemo(
    () =>
      new SaveVeterinaryClinicDto({
        veterinaryId: veterinary.veterinaryId,
        clinicId: +id,
      }),
    [id, veterinary.veterinaryId],
  );

  return (
    <SmallFormGenerator
      onSubmit={saveItem}
      loading={saving}
      initialValues={initialData}
      editMode={true}
      hideButtons={true}
    >
      <FGCustomInput label={t(ETLCodes.Veterinarians)} name="authorizedVeterinary">
        {() => <div>{veterinary.name}</div>}
      </FGCustomInput>
      <FGEmpty />
      <FGCustomPanel>
        {(ctx) => (
          <ButtonContainer>
            <SaveButton minimal={false} loading={saving} onClick={() => saveItem(ctx.formik.values)} />
          </ButtonContainer>
        )}
      </FGCustomPanel>
    </SmallFormGenerator>
  );
};
